import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ResourceLink from '../Common/ResourceLink';

class BoundTo extends Component {
    render() {
        return (
            <div style={{
                display: 'inline-block',
                margin: '5px',
                padding: '10px',
                backgroundColor: '#e0e0e0',
                borderRadius: '20px',
                fontSize: '13px',
            }}>
                <ResourceLink
                    resourceId={this.props.resourceId}
                    resourceType={this.props.resourceType}
                    openContent={this.props.openContent}
                    openFileViewer={this.props.openFileViewer}
                />
            </div>
        );
    }
}
BoundTo.propTypes = {
    resourceType: PropTypes.string.isRequired,
    resourceId: PropTypes.string.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
};

export default BoundTo;